import React from 'react';
// eslint-disable-next-line react/jsx-no-useless-fragment
const EmptyComponent = () => <></>;
export default EmptyComponent;
